import React from 'react'

const JourneyItem = ({ item }) => {
    return (
        <div className={`resume-item border-line-h ${item.active && 'active'}`}>
            <div className="date">{item.date}</div>
            <div className="name">{item.name}</div>
            {item.type && <div style={{...typeStyles, color: item.typeColor}}>{item.type}</div>} 
            <div className="company">{item.company}</div>
            
            <div dangerouslySetInnerHTML={{ __html: item.description}}></div>
        </div>
    )
}

const typeStyles = {
    display: 'inline-flex',
    border: '1px solid',
    borderRadius: '4px',
    padding: '0px 4px',
    fontSize: '0.7rem',
};

export default JourneyItem